import { render, staticRenderFns } from "./SaveQuoteModal.vue?vue&type=template&id=195a4d38&scoped=true&"
import script from "./SaveQuoteModal.vue?vue&type=script&lang=js&"
export * from "./SaveQuoteModal.vue?vue&type=script&lang=js&"
import style0 from "./SaveQuoteModal.vue?vue&type=style&index=0&id=195a4d38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195a4d38",
  null
  
)

export default component.exports